/**
 * Fullscreen Handling
 */
/* eslint-disable no-underscore-dangle */
const Flickity = require('flickity');

Flickity.createMethods.push('_createPluginMdsFullscreen');

const triggerClassName = 'js-slider-fullscreen';
const proto = Flickity.prototype;
proto._createPluginMdsFullscreen = function createPluginMdsFullscreen() {
  this.on('ready', () => {
    if (!this.options.fullscreen) {
      return;
    }

    const groupCellsCurrent = this.options.groupCells;

    const fullscreenTrigger = this.element.classList.contains(triggerClassName);
    if (fullscreenTrigger) {
      const openFullscreen = (event, pointer, cellElement, cellIndex) => {
        if (cellElement && !this.isFullscreen) {
          if (groupCellsCurrent === true) {
            this.options.groupCells = false;
            this.on('fullscreenChange', (isFull) => {
              if (isFull === false) {
                // leave fullscreen reset groupCells
                this.options.groupCells = true;
                setTimeout(() => this.resize(), 350);
              }
            });
          }
          this.viewFullscreen();
          this.selectCell(cellIndex, false, true);
        }
      };

      this.on('staticClick', openFullscreen);
    }
  });
};
